import type { InternalCookieOptions } from './types';
import type { BenefitProgram } from './benefitCookie';
import { getExpiresInMonths, setCookie } from './utils';

const COOKIE_NAME = 'stbb';

const isEmployerBenefitProgram = (program: BenefitProgram): boolean =>
  program.code !== '70' && !!program.organizationNumber;

/**
 * Sets the `stbb` cookie from pre-fetched data.
 * Format: `{hasEmployerBenefits}{isFramMember}` where each is `t` or `f`.
 */
export const writeStorebrandBenefitsCookie = (
  programs: BenefitProgram[],
  isFramMember: boolean,
  options: InternalCookieOptions,
): void => {
  const hasEmployerBenefits = programs.some(isEmployerBenefitProgram);
  const value = `${hasEmployerBenefits ? 't' : 'f'}${isFramMember ? 't' : 'f'}`;
  setCookie(COOKIE_NAME, value, options, getExpiresInMonths(1));
};
